// extracted by mini-css-extract-plugin
export var footer = "_op-0";
export var inherit = "_op-1";
export var input = "_op-2";
export var modalContent = "_op-3";
export var quillEditor = "_op-4";
export var subtitle = "_op-5";